export enum UserRole {
    Admin = 'admin',
    Teacher = 'teacher',
    SuperAdmin = 'super-admin',
    InstructionalDesigner = 'instructional-designer',
    ClassManager = 'class-manager',
    Student = 'student',
    CustomerSupport = 'customer-support'
}

export const systemRoles: UserRole[] = [
    UserRole.Admin,
    UserRole.ClassManager,
    UserRole.Teacher,
    UserRole.InstructionalDesigner
];

export interface User {
    name: string;
    email?: string;
    ext_user_id?: string;
    roles: UserRole[];
}
